import {
  UPDATEWITHDRWALCOUNT_SUCCESS,
  UPDATEWITHDRWALCOUNT_FAILED,
  RESET_UPDATEWITHDRWALCOUNT,
  LOADING_UPDATEWITHDRWALCOUNT,
  NETWORK_ERROR_UPDATEWITHDRWALCOUNT,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATEWITHDRWALCOUNT:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATEWITHDRWALCOUNT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATEWITHDRWALCOUNT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATEWITHDRWALCOUNT:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATEWITHDRWALCOUNT:
      return (state = initialState);
    default:
      return state;
  }
};
